import { User } from 'dashboard/models/user';
import { UserAuditLog } from 'dashboard/models/user-audit-log';
import Action from 'lib/interfaces/Action';

export type UserAuditLogActions =
  | Action<UserAuditLogActionType.ClearUserAuditLog>
  | Action<UserAuditLogActionType.SetUserAuditLog, SetUserAuditLogPayload>;

export enum UserAuditLogActionType {
  ClearUserAuditLog = 'user-audit-log/CLEAR_USER_AUDIT_LOG',
  SetUserAuditLog = 'user-audit-log/SET_USER_AUDIT_LOG',
}

export function clearUserAuditLog(): Action<UserAuditLogActionType.ClearUserAuditLog> {
  return { type: UserAuditLogActionType.ClearUserAuditLog };
}

interface SetUserAuditLogPayload {
  userAuditLog: UserAuditLog;
  user: User;
}

export function setUserAuditLog(
  userAuditLog: UserAuditLog,
  user: User,
): Action<UserAuditLogActionType.SetUserAuditLog, SetUserAuditLogPayload> {
  return {
    payload: {
      userAuditLog,
      user,
    },
    type: UserAuditLogActionType.SetUserAuditLog,
  };
}
